export default {
  env: 'beta',
  version: "1.6.51",
  api: {
    base_url: 'https://us-central1-usabg-backoffice-beta.cloudfunctions.net/api/',
    automation_url: 'https://beta.automation.usabg.com'
  },
  integrations: {
    google_tag_manager: {
      tag: 'GTM-W3M2CQ7K',
    },
    google_analytics: {
      tag: 'G-L6V075GZE4'
    },
    stripe: {
      key: 'pk_test_51J0X48CB1dfLO0v7p9krpHXCl6D30voPfsb6xdXse8ea368xRhyfs7QLB27zPpK0SZkbY8NfkAWiO2cwAFjLIoSH00hH09hepr',
    },
    track_js: {
      token: '6d9aba7876784482b2ddd727803a0b1f',
      application: 'acdtk00ko6qeb8hgogqyshf2c',
    },
    firebase: {
      config: {
        apiKey: 'AIzaSyCfi4gfdQJL2DeCdAV2nEN98ucNgjAki_4',
        authDomain: 'usabg-backoffice-beta.firebaseapp.com',
        projectId: 'usabg-backoffice-beta',
        storageBucket: 'usabg-backoffice-beta.appspot.com',
        messagingSenderId: '444081365797',
        appId: '1:444081365797:web:9dd78b3f86b1f67e8970cc',
        vapidKey: 'BPJx3ZFyjGShwYpqXWFS7CwR-SEq06638mMZZHxjXyWT8mxwrMGfhpAryhjz4i8nWSQsobDFwxdn8UuglxrGwWQ'
      },
      appCheck: {
        recaptchaSiteKey: '6Lf0UjQtAAAAAFR5pY4i0AOdiOgdSter7z7xEU_o',   // dev: leave '' (App Check inactive locally); beta/prod: the project's v3 site key
        debugToken: '6AB6EC62-805C-4611-862D-98D711578B90',         // local/dev only if you want a debug token; empty in beta/prod
      }
    },
    adobe_sign: {
      client_id: 'CBJCHBCAABAAT5hSWPjrVaMSDlB78FLxzsM24XEvT0s5',
    },
    bm10x: {
      enable: true,
      client_id: '6669b4a4d4d6f250df6264a2-m8q6u5rw',
      redirect_url: `https://beta.automation.usabg.com/nova-vendor/bm10x-dashboard/bm10x/oauth/location`
    },
    google_recaptcha: {
			key: "6LeRkY0sAAAAADCr7hejVORhJESfvYfD-xIpgFUn"
    },
  },
}